import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
// import { getToken } from '@/utils/auth'

export default {
  addBuyerOffer: function(params) {
    return request({
      url: '/AddBuyerOffer',
      method: 'post',
      data: {
        MessageType: 3001,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin,
          Cuts: params.Cuts,
          PlantNo: params.PlantNo,
          Quantity: params.Quantity,
          Price: params.Price,
          Destination: params.Destination,
          Port: params.Port,
          ShippingDate: params.ShippingDate,
          Grade: params.Grade,
          WithBone: params.WithBone,
          Islamic: params.Islamic,
          FeedingWay: params.FeedingWay,
          NeedBTCProxy: params.NeedBTCProxy,
          ExpireDate: params.ExpireDate,
          Note: params.Note,
          UserID: params.UserID,
          OfferType: params.OfferType,
          GoodsType: params.GoodsType,
          PurchaseType: params.PurchaseType,
          IsSync: params.IsSync
        }
      }
    })
  },

  getBuyerOffers: function(params) {
    return request({
      url: '/GetBuyerOffers',
      method: 'post',
      data: {
        MessageType: 3002,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          GoodsType: params.GoodsType,
          UserID: params.UserID,
          OfferType: '_buy',
          Keyword: params.Keywords
        }
      }
    })
  },

  getSmartPushInfo: function(params) {
    return request({
      url: '/GetSmartPushInfo',
      method: 'post',
      data: {
        MessageType: 3003,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID,
          OfferID: params.OfferID,
          ArrivalTimeType: params.ArrivalTimeType
        }
      }
    })
  },

  getBtcPushInfo: function(params) {
    return request({
      url: '/GetBtcPushInfo',
      method: 'post',
      data: {
        MessageType: 3004,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID
        }
      }
    })
  },

  getOfferDetail: function(params) {
    return request({
      url: '/GetOfferDetail',
      method: 'post',
      data: {
        MessageType: 3005,
        MessageID: btcguid(),
        Data: {
          BuyerOfferID: params.BuyerOfferID,
          SellerOfferID: params.SellerOfferID
        }
      }
    })
  },

  buyerConfirmOrder: function(params) {
    return request({
      url: '/BuyerConfirmOrder',
      method: 'post',
      data: {
        MessageType: 3006,
        MessageID: btcguid(),
        Data: {
          BuyerOfferID: params.BuyerOfferID,
          SellerOfferID: params.SellerOfferID,
          BuyerUserState: params.BuyerUserState,
          UserID: params.UserID
        }
      }
    })
  },

  getBuyerOfferState: function(params) {
    return request({
      url: '/GetBuyerOfferState',
      method: 'post',
      data: {
        MessageType: 3007,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID
        }
      }
    })
  },

  getSellerOffers: function(params) {
    return request({
      url: '/GetSellerOffers',
      method: 'post',
      data: {
        MessageType: 3008,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID,
          OfferType: '_sell_asm',
          GoodsType: params.GoodsType
        }
      }
    })
  },

  sellerConfirmOrder: function(params) {
    return request({
      url: '/SellerConfirmOrder',
      method: 'post',
      data: {
        MessageType: 3009,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID
        }
      }
    })
  },

  getAssemblyOfferDetail: function(params) {
    return request({
      url: '/GetAssemblyOfferDetail',
      method: 'post',
      data: {
        MessageType: 3010,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SellerOfferID: params.SellerOfferID
        }
      }
    })
  },

  getSellerFuturesOffers: function(params) {
    return request({
      url: '/GetSellerFuturesOffers',
      method: 'post',
      data: {
        MessageType: 3011,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID
        }
      }
    })
  },

  sellerQuate: function(params) {
    return request({
      url: '/SellerQuate',
      method: 'post',
      data: {
        MessageType: 3012,
        MessageID: btcguid(),
        Data: {
          SellerOfferID: params.SellerOfferID,
          SellerUserID: params.SellerUserID,
          SellerPrice: params.SellerPrice,
          AvaliableQuantity: params.AvaliableQuantity,
          Expiry: params.Expiry
        }
      }
    })
  },

  getSellerState: function(params) {
    return request({
      url: '/GetSellerState',
      method: 'post',
      data: {
        MessageType: 3013,
        MessageID: btcguid(),
        Data: {
          SellerOfferID: params.SellerOfferID,
          SellerUserID: params.SellerUserID
        }
      }
    })
  },

  getBuyerOfferByID: function(params) {
    return request({
      url: '/GetBuyerOfferByID',
      method: 'post',
      data: {
        MessageType: 3014,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID
        }
      }
    })
  },

  buyerConfirmFuturesOffer: function(params) {
    return request({
      url: '/BuyerConfirmFuturesOffer',
      method: 'post',
      data: {
        MessageType: 3015,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID
        }
      }
    })
  },

  updateSellerState: function(params) {
    return request({
      url: '/UpdateSellerState',
      method: 'post',
      data: {
        MessageType: 3016,
        MessageID: btcguid(),
        Data: {
          SellerOfferID: params.SellerOfferID,
          SellerUserID: params.SellerUserID,
          SellerUserState: params.SellerUserState
        }
      }
    })
  },

  hasSellerAccepted: function(params) {
    return request({
      url: '/HasSellerAccepted',
      method: 'post',
      data: {
        MessageType: 3017,
        MessageID: btcguid(),
        Data: {
          SellerOfferID: params.SellerOfferID,
          SellerUserID: params.SellerUserID
        }
      }
    })
  },

  updateSellerFlag: function(params) {
    return request({
      url: '/UpdateSellerFlag',
      method: 'post',
      data: {
        MessageType: 3018,
        MessageID: btcguid(),
        Data: {
          SellerOfferID: params.SellerOfferID,
          SellerUserID: params.SellerUserID
        }
      }
    })
  },

  getFuturesAssemblyOfferDetail: function(params) {
    return request({
      url: '/GetFuturesAssemblyOfferDetail',
      method: 'post',
      data: {
        MessageType: 3019,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SellerOfferID: params.SellerOfferID,
          SellerUserID: params.SellerUserID
        }
      }
    })
  },

  getCompanyInfoByUserName: function(params) {
    return request({
      url: '/GetCompanyInfoByUserName',
      method: 'post',
      data: {
        MessageType: 3020,
        MessageID: btcguid(),
        Data: {
          CompanyID: params.CompanyID
        }
      }
    })
  },

  getSmartPushViewNumber: function(params) {
    return request({
      url: '/GetSmartPushViewNumber',
      method: 'post',
      data: {
        MessageType: 3021,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          OfferID: params.OfferID
        }
      }
    })
  },

  getFuturesOfferDetail: function(params) {
    return request({
      url: '/GetFuturesOfferDetail',
      method: 'post',
      data: {
        MessageType: 3021,
        MessageID: btcguid(),
        Data: {
          BuyerOfferID: params.BuyerOfferID
        }
      }
    })
  },

  getFuturesAssemblyBuyerDetail: function(params) {
    return request({
      url: '/GetFuturesAssemblyBuyerDetail',
      method: 'post',
      data: {
        MessageType: 3022,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SellerOfferID: params.SellerOfferID
        }
      }
    })
  },

  getCompanySupplyInfo: function(params) {
    return request({
      url: '/GetCompanySupplyInfo',
      method: 'post',
      data: {
        MessageType: 3023,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          Origin: params.Origin,
          Cuts: params.Cuts,
          PlantNo: params.PlantNo,
          DateInterval: params.DateInterval,
          Keywords: params.Keywords
        }
      }
    })
  },

  updateCompanySupplyInfo: function(params) {
    return request({
      url: '/UpdateCompanySupplyInfo',
      method: 'post',
      data: {
        MessageType: 3024,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          Origin: params.Origin,
          Cuts: params.Cuts,
          PlantNo: params.PlantNo,
          SourceState: params.SourceState,
          Quantity: params.Quantity
        }
      }
    })
  },

  getRealTimeOfferOfSupplier: function(params) {
    return request({
      url: '/GetRealTimeOfferOfSupplier',
      method: 'post',
      data: {
        MessageType: 3025,
        MessageID: btcguid(),
        Data: {
          CompanyDataID: params.CompanyDataID,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          Origin: params.Origin,
          Cuts: params.Cuts,
          PlantNo: params.PlantNo,
          CompanyID: params.CompanyID
        }
      }
    })
  },

  getCompanySupplyInfoFilter: function(params) {
    return request({
      url: '/GetCompanySupplyInfoFilter',
      method: 'post',
      data: {
        MessageType: 3026,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID
        }
      }
    })
  },

  // ``````````````````````````````````````````````````` 期货 ```````````````````````````````````````````````````````

  getImportersList: function(params) {
    return request({
      url: '/GetImportersList',
      method: 'post',
      data: {
        MessageType: 3027,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          Keyword: params.Keyword
        }
      }
    })
  },
  getImporterContact: function(params) {
    return request({
      url: '/GetImporterContact',
      method: 'post',
      data: {
        MessageType: 3028,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          CompanyID: params.CompanyID,
          ImportersID: params.ImportersID
        }
      }
    })
  },
  getTradingReference: function(params) {
    return request({
      url: '/GetTradingReference',
      method: 'post',
      data: {
        MessageType: 3029,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          ImportersID: params.ImportersID
        }
      }
    })
  },
  getTradingReferenceOrigin: function(params) {
    return request({
      url: '/GetTradingReferenceOrigin',
      method: 'post',
      data: {
        MessageType: 3030,
        MessageID: btcguid(),
        Data: {
        }
      }
    })
  },
  getTradingReferencePlantNo: function(params) {
    return request({
      url: '/GetTradingReferencePlantNo',
      method: 'post',
      data: {
        MessageType: 3031,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin
        }
      }
    })
  },
  getTradingReferenceDetail: function(params) {
    return request({
      url: '/GetTradingReferenceDetail',
      method: 'post',
      data: {
        MessageType: 3032,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          StartDate: params.StartDate,
          EndingDate: params.EndingDate,
          ImportersID: params.ImportersID
        }
      }
    })
  },
  getExporterInfo: function(params) {
    return request({
      url: '/GetExporterInfo',
      method: 'post',
      data: {
        MessageType: 3033,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID
        }
      }
    })
  },
  updateExporterInfo: function(params) {
    return request({
      url: '/UpdateExporterInfo',
      method: 'post',
      data: {
        MessageType: 3034,
        MessageID: btcguid(),
        Data: {
          CompanyID: params.CompanyID,
          CompanyName: params.CompanyName,
          CompanyPhoneNumber: params.CompanyPhoneNumber,
          CompanyEmail: params.CompanyEmail,
          CompanyWebSite: params.CompanyWebSite,
          ContactPersonName: params.ContactPersonName
        }
      }
    })
  },
  // --------------------------------------------------------------------- 新API --------------------------------------
  getApprovedPlantOrigins: function(params) {
    return request({
      url: '/GetApprovedPlantOrigins',
      method: 'post',
      data: {
        MessageType: 3035,
        MessageID: btcguid(),
        Data: {
        }
      }
    })
  },
  getApprovedPlantNo: function(params) {
    return request({
      url: '/GetApprovedPlantNo',
      method: 'post',
      data: {
        MessageType: 3036,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin
        }
      }
    })
  },
  getApprovedPlantInfo: function(params) {
    return request({
      url: '/GetApprovedPlantInfo',
      method: 'post',
      data: {
        MessageType: 3037,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          UserID: params.UserID
        }
      }
    })
  },
  approvedPlantCollection: function(params) {
    return request({
      url: '/ApprovedPlantCollection',
      method: 'post',
      data: {
        MessageType: 3038,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          ApprovedPlantsID: params.ApprovedPlantsID
        }
      }
    })
  },
  approvedPlantSearchCount: function(params) {
    return request({
      url: '/ApprovedPlantSearchCount',
      method: 'post',
      data: {
        MessageType: 3039,
        MessageID: btcguid(),
        Data: {
          PlantNo: params.PlantNo
        }
      }
    })
  },
  getApprovedPlantCollection: function(params) {
    return request({
      url: '/GetApprovedPlantCollection',
      method: 'post',
      data: {
        MessageType: 3040,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID
        }
      }
    })
  },
  getPlantSearchInfo: function(params) {
    return request({
      url: '/GetPlantSearchInfo',
      method: 'post',
      data: {
        MessageType: 3041,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID
        }
      }
    })
  },
  uploadPlantAppendix: function(params) {
    const formData = new FormData()
    formData.append('MessageType', 3042)
    formData.append('MessageID', btcguid())
    formData.append('Files', params.Files)
    formData.append('CompanyID', params.CompanyID)
    formData.append('AppendixType', params.AppendixType)
    return request({
      url: '/UploadPlantAppendix',
      method: 'post',
      // headers: {
      //   'Authorization': getToken(),
      //   'Content-Type': 'multipart/form-data'
      // },
      data: formData
    })
  },
  sendFuturesEmail: function(params) {
    return request({
      url: '/SendFuturesEmail',
      method: 'post',
      data: {
        MessageType: 3043,
        MessageID: btcguid(),
        Data: {
          Content: params.Content,
          Sender: params.Sender,
          Receiver: params.Receiver,
          SenderUserID: params.SenderUserID,
          ReceiverUserID: params.ReceiverUserID,
          ReplyEmailID: params.ReplyEmailID,
          ReceiverType: params.ReceiverType,
          ReceiverSecondID: params.ReceiverSecondID,
          ReceiverExporterID: params.ReceiverExporterID,
          AppendixID: params.AppendixID,
          Type: params.Type
        }
      }
    })
  },
  getImporterReceive: function(params) {
    return request({
      url: '/GetImporterReceive',
      method: 'post',
      data: {
        MessageType: 3044,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize
        }
      }
    })
  },
  getImporterReceiveMails: function(params) {
    return request({
      url: '/GetImporterReceiveMails',
      method: 'post',
      data: {
        MessageType: 3045,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SenderUserID: params.SenderUserID,
          ReceiverUserID: params.ReceiverUserID
        }
      }
    })
  },
  getExporterReceiveMails: function(params) {
    return request({
      url: '/GetExporterReceiveMails',
      method: 'post',
      data: {
        MessageType: 3046,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SenderUserID: params.SenderUserID,
          ReceiverUserID: params.ReceiverUserID
        }
      }
    })
  },
  getImporterReceiveMailDetail: function(params) {
    return request({
      url: '/GetImporterReceiveMailDetail',
      method: 'post',
      data: {
        MessageType: 3047,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          EmailID: params.EmailID
        }
      }
    })
  },
  getExporterReceiveMailDetail: function(params) {
    return request({
      url: '/GetExporterReceiveMailDetail',
      method: 'post',
      data: {
        MessageType: 3048,
        MessageID: btcguid(),
        Data: {
          IsRead: params.IsRead,
          UserID: params.UserID,
          EmailID: params.EmailID,
          SenderUserID: params.SenderUserID
        }
      }
    })
  },
  getImporterSender: function(params) {
    return request({
      url: '/GetImporterSender',
      method: 'post',
      data: {
        MessageType: 3049,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize
        }
      }
    })
  },
  getImporterSenderMails: function(params) {
    return request({
      url: '/GetImporterSenderMails',
      method: 'post',
      data: {
        MessageType: 3050,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SenderUserID: params.SenderUserID,
          ReceiverExporterID: params.ReceiverExporterID
        }
      }
    })
  },
  getImporterSenderMailDetail: function(params) {
    return request({
      url: '/GetImporterSenderMailDetail',
      method: 'post',
      data: {
        MessageType: 3051,
        MessageID: btcguid(),
        Data: {
          EmailID: params.EmailID
        }
      }
    })
  },
  getExporterSender: function(params) {
    return request({
      url: '/GetExporterSender',
      method: 'post',
      data: {
        MessageType: 3052,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize
        }
      }
    })
  },
  getExporterSenderMails: function(params) {
    return request({
      url: '/GetExporterSenderMails',
      method: 'post',
      data: {
        MessageType: 3053,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SenderUserID: params.SenderUserID,
          ReceiverUserID: params.ReceiverUserID,
          ReceiverSecondID: params.ReceiverSecondID,
          ReceiverExporterID: params.ReceiverExporterID,
          Type: params.Type
        }
      }
    })
  },
  getExporterSenderMailDetail: function(params) {
    return request({
      url: '/GetExporterSenderMailDetail',
      method: 'post',
      data: {
        MessageType: 3054,
        MessageID: btcguid(),
        Data: {
          EmailID: params.EmailID
        }
      }
    })
  },
  getExporterReceive: function(params) {
    return request({
      url: '/GetExporterReceive',
      method: 'post',
      data: {
        MessageType: 3055,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          SenderUserID: params.SenderUserID
        }
      }
    })
  },
  getTradingRefComments: function(params) {
    return request({
      url: '/GetTradingRefComments',
      method: 'post',
      data: {
        MessageType: 3056,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID,
          ImporterID: params.ImporterID
        }
      }
    })
  },
  getTradingRefCommentChildren: function(params) {
    return request({
      url: '/GetTradingRefCommentChildren',
      method: 'post',
      data: {
        MessageType: 3057,
        MessageID: btcguid(),
        Data: {
          ParentCommentsID: params.ParentCommentsID,
          PageNum: params.PageNum,
          PageSize: params.PageSize
        }
      }
    })
  },
  postTradingRefComments: function(params) {
    return request({
      url: '/PostTradingRefComments',
      method: 'post',
      data: {
        MessageType: 3058,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          ImporterID: params.ImporterID,
          IsAnonymously: params.IsAnonymously,
          CommentsContent: params.CommentsContent,
          ParentCommentsID: params.ParentCommentsID
        }
      }
    })
  },
  postTradingRefCommentLisk: function(params) {
    return request({
      url: '/PostTradingRefCommentLisk',
      method: 'post',
      data: {
        MessageType: 3059,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          CommentsID: params.CommentsID
        }
      }
    })
  },
  getApprovedPlantByID: function(params) {
    return request({
      url: '/GetApprovedPlantByID',
      method: 'post',
      data: {
        MessageType: 3060,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          ApprovedPlantsID: params.ApprovedPlantsID
        }
      }
    })
  },
  getImportersByID: function(params) {
    return request({
      url: '/GetImportersByID',
      method: 'post',
      data: {
        MessageType: 3061,
        MessageID: btcguid(),
        Data: {
          IsRead: params.IsRead,
          UserID: params.UserID,
          ImportersID: params.ImportersID
        }
      }
    })
  },
  importerHasUnreadMail: function(params) {
    return request({
      url: '/ImporterHasUnreadMail',
      method: 'post',
      data: {
        MessageType: 3062,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID
        }
      }
    })
  },
  deleteEmailAppendix: function(params) {
    return request({
      url: '/DeleteEmailAppendix',
      method: 'post',
      data: {
        MessageType: 3063,
        MessageID: btcguid(),
        Data: {
          AppendixID: params.AppendixID
        }
      }
    })
  },
  getApprovePlantStateOrigin: function(params) {
    return request({
      url: '/GetApprovePlantStateOrigin',
      method: 'post',
      data: {
        MessageType: 3064,
        MessageID: btcguid(),
        Data: {
          IsEn: params.IsEn
        }
      }
    })
  },
  getApprovePlantStatePlantNO: function(params) {
    return request({
      url: '/GetApprovePlantStatePlantNO',
      method: 'post',
      data: {
        MessageType: 3065,
        MessageID: btcguid(),
        Data: {
          Origin: params.Origin
        }
      }
    })
  },
  getApprovePlantState: function(params) {
    return request({
      url: '/GetApprovePlantState',
      method: 'post',
      data: {
        MessageType: 3066,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          UpdateState: params.UpdateState,
          UserID: params.UserID,
          LanguageCode: params.LanguageCode,
          IsFirst: params.IsFirst,
          Year: params.Year,
          Month: params.Month,
          Type: params.Type
        }
      }
    })
  },
  getApprovePlantChildState: function(params) {
    return request({
      url: '/GetApprovePlantChildState',
      method: 'post',
      data: {
        MessageType: 3067,
        MessageID: btcguid(),
        Data: {
          PlantNo: params.PlantNo,
          ApproveStateID: params.ApproveStateID,
          Type: params.Type
        }
      }
    })
  },
  getFactoryPermission: function(params) {
    return request({
      url: '/GetFactoryPermission',
      method: 'post',
      data: {
        MessageType: 3068,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID
        }
      }
    })
  },
  getSmartPushChildInfo: function(params) {
    return request({
      url: '/GetSmartPushChildInfo',
      method: 'post',
      data: {
        MessageType: 3069,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID,
          Cuts: params.Cuts,
          Origin: params.Origin,
          CompanyName: params.CompanyName,
          CompanyID: params.CompanyID,
          ArrivalTimeType: params.ArrivalTimeType
        }
      }
    })
  },
  getSmartPushInfolimit: function(params) {
    return request({
      url: '/GetSmartPushInfolimit',
      method: 'post',
      data: {
        MessageType: 3070,
        MessageID: btcguid(),
        Data: {
          PageNum: params.PageNum,
          PageSize: params.PageSize,
          UserID: params.UserID,
          OfferID: params.OfferID,
          ArrivalTimeType: params.ArrivalTimeType,
          CompanyName: params.CompanyName
        }
      }
    })
  },
  getSmartPushChildInfoLimit: function(params) {
    return request({
      url: '/GetSmartPushChildInfoLimit',
      method: 'post',
      data: {
        MessageType: 3071,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID,
          Cuts: params.Cuts,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          CompanyName: params.CompanyName,
          CompanyID: params.CompanyID,
          ArrivalTimeType: params.ArrivalTimeType
        }
      }
    })
  },
  addRealTimeSource: function(params) {
    return request({
      url: '/AddRealTimeSource',
      method: 'post',
      data: {
        MessageType: 3072,
        MessageID: btcguid(),
        Data: {
          Cuts: params.Cuts,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          Quantity: params.Quantity,
          UserID: params.UserID,
          IsSync: params.IsSync
        }
      }
    })
  },
  updateRealTimeSource: function(params) {
    return request({
      url: '/UpdateRealTimeSource',
      method: 'post',
      data: {
        MessageType: 3072,
        MessageID: btcguid(),
        Data: {
          Cuts: params.Cuts,
          Origin: params.Origin,
          PlantNo: params.PlantNo,
          Quantity: params.Quantity,
          UserID: params.UserID,
          SourceState: params.SourceState,
          IsNotify: params.IsNotify,
          IsSync: params.IsSync
        }
      }
    })
  },
  deleteSmartPushDot: function(params) {
    return request({
      url: '/DeleteSmartPushDot',
      method: 'post',
      data: {
        MessageType: 3073,
        MessageID: btcguid(),
        Data: {
          OfferID: params.OfferID
        }
      }
    })
  },
  getUserNewSmartPush: function(params) {
    return request({
      url: '/GetUserNewSmartPush',
      method: 'post',
      data: {
        MessageType: 3074,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID
        }
      }
    })
  },
  getUserNewRealTimeOffer: function(params) {
    return request({
      url: '/GetUserNewRealTimeOffer',
      method: 'post',
      data: {
        MessageType: 3075,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID
        }
      }
    })
  },
  clearRealTimeDemandDot: function(params) {
    return request({
      url: '/ClearRealTimeDemandDot',
      method: 'post',
      data: {
        MessageType: 3076,
        MessageID: btcguid(),
        Data: {
          IDs: params.IDs
        }
      }
    })
  },
  // 获取必孚金融实时汇率
  getFinancialRate: function(params) {
    return request({
      url: '/GetFinancialRate',
      method: 'post',
      data: {
        MessageType: 3077,
        MessageID: btcguid(),
        Data: {
        }
      }
    })
  },
  // 提交必孚金融需求
  commitFinancialRequest: function(params) {
    return request({
      url: '/CommitFinancialRequest',
      method: 'post',
      data: {
        MessageType: 3078,
        MessageID: btcguid(),
        Data: {
          CompanyName: params.companyName,
          ContactPerson: params.contactPersonName,
          ContactPhone: params.companyPhoneNumber,
          Note: params.note,
          IsRegistered: params.isRegistered,
          Type: params.type,
          UserID: params.userID
        }
      }
    })
  },
  // 获取代理公司列表
  getBeefAgent: function(params) {
    return request({
      url: '/GetBeefAgent',
      method: 'post',
      data: {
        MessageType: 3079,
        MessageID: btcguid(),
        Data: {
          PageSize: params.pageSize,
          PageNum: params.pageNum
        }
      }
    })
  },
  // 上传必孚肉集图片
  uploadCirclePicture: function(params) {
    const formData = new FormData()
    formData.append('MessageType', 3076)
    formData.append('MessageID', btcguid())
    formData.append('Files', params.Files)
    formData.append('UserID', params.UserID)
    return request({
      url: '/UploadCirclePicture',
      method: 'post',
      data: formData
    })
  },
  // 发布圈
  publishCircle: function(params) {
    return request({
      url: '/PublishCircle',
      method: 'post',
      data: {
        MessageType: 3080,
        MessageID: btcguid(),
        Data: {
          Type: params.Type,
          UserID: params.UserID,
          Content: params.Content,
          circlePictures: params.circlePictures
        }
      }
    })
  },
  // 获取必孚代理金融
  getFinancialAppeal: function(params) {
    return request({
      url: '/GetFinancialAppeal',
      method: 'post',
      data: {
        MessageType: 3081,
        MessageID: btcguid(),
        Data: {
          PageSize: params.pageSize,
          PageNum: params.pageNum,
          UserID: params.userID,
          IsRegistered: params.isRegistered,
          Type: params.type
        }
      }
    })
  },
  // 获取用户代理采销
  getAgentUserCircle: function(params) {
    return request({
      url: '/GetAgentUserCircle',
      method: 'post',
      data: {
        MessageType: 3082,
        MessageID: btcguid(),
        Data: {
          PageSize: params.pageSize,
          PageNum: params.pageNum,
          UserID: params.userID,
          Type: params.type
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/trade.js